<template>
	<cube-scroll ref="scroll" class="order" :options="scrollOptions">
		<div class="advwrap"></div>
		<div class="order-content">
			<div class="title-bar">
				<i class="cubeic-back title-back" @click="back"></i>
				支付结果
			</div>
			<div class="header">
				<img src="../../common/img/icon_pay_completed.png"/>
				<div class="money">
					成功支付 ￥
					<div>0</div>
				</div>
			</div>
			<div class="pay-list">
				<div class="pay-item">
					<div>本次交易金额</div>
					<div>￥ 0</div>
				</div>
				<div class="pay-item">
					<div>优惠券扣除</div>
					<div>￥ {{couponFee}}</div>
				</div>
				<div class="pay-item">
					<div>交易时间</div>
					<div>{{getTime()}}</div>
				</div>
				<div class="pay-item">
					<div>入场时间</div>
					<div>{{parkrec.inTime}}</div>
				</div>
				<div class="pay-item">
					<div>出场时间</div>
					<div>{{getTime()}}</div>
				</div>
			</div>
		</div>
	</cube-scroll>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                ratings: [],
                scrollOptions: {
                    click: true,
                    directionLockThreshold: 0
                },
                totalPrice: 0
            };
        },
        computed: {
            ...mapGetters(["parkrec", "couponFee",'abParkId'])
        },
		mounted () {
            this.$getAdInfo(this.abParkId)
		},
        methods: {
            back() {
                this.$router.push("Scan");
            },
            getTime() {
                let yy = new Date().getFullYear();
                let mm =
                    new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1;
                let dd =
                    new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate();
                let hh =
                    new Date().getHours() < 10
                        ? "0" + new Date().getHours()
                        : new Date().getHours();
                let mf =
                    new Date().getMinutes() < 10
                        ? "0" + new Date().getMinutes()
                        : new Date().getMinutes();
                let ss =
                    new Date().getSeconds() < 10
                        ? "0" + new Date().getSeconds()
                        : new Date().getSeconds();

                return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
            }
        }
    };
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.order {
		position: relative;
		text-align: left;
		white-space: normal;
		width: 100%;
		height: 100%;
		background: #ffffff;
		box-sizing: border-box;
		padding-bottom: 50px;
		.advwrap{
			/*width 100%*/
			/*height 0*/
			/*padding-bottom 40%*/
		}
		.title-bar {
			color #0d0d0d
			width: 100%;
			height: 40px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			border-bottom: 1px solid #f5f5f5;
			z-index: 100;

			.title-back {
				position: absolute;
				left: 8px;
				padding: 8px;
				z-index: 101;
			}
		}

		.header {
			width: 100%;
			height: 150px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			background: #ffffff;
			color: #333333;
			box-sizing: border-box;

			img {
				width 60px
				height 60px
			}

			.money {
				display flex
				flex-direction row
				align-items center
				margin-top 12px
			}
		}

		.pay-list {
			color #0d0d0d
			width: 100%;
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			padding-left: 12px;
			padding-right: 12px;
			font-size: 14px;

			.pay-item {
				color #0d0d0d
				width: 100%;
				height: 50px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #f5f5f5;
				font-size: 14px;

				.item-left {
					display: flex;
					flex-direction: row;
					align-items: center;

					img {
						width: 18px;
						height: 18px;
						margin-right: 16px;
					}
				}

				.checked {
					width: 18px;
					height: 18px;
					margin-right: 10px;
					padding: 6px;
				}
			}

			.none-border {
				border: none;
			}
		}
	}
</style>
